/* eslint-disable @next/next/no-img-element */

// @material-tailwind/react components
import { Typography } from "@material-tailwind/react";

// page components
import CodePreview from "components/cards/code-preview";

export default function SectionColorsPalette() {
  return (
    <section className="py-24">
      <div className="flex flex-wrap items-center">
        <div className="relative w-full px-4 md:w-6/12">
          <CodePreview
            code={`
import java.util.Scanner;

public class Main {
    public static void main(String[] args) {
        Scanner scanner = new Scanner(System.in);
        System.out.print("Enter your age: ");
        int age = scanner.nextInt();

        if (age >= 18) {
            System.out.println("Above 18");
        } else {
            System.out.println("Under 18");
        }
    }
}
`}
          />
          <img
            className="absolute -bottom-28 w-full md:top-36 md:-right-24 md:bottom-auto lg:top-24 lg:-left-52"
            src="/img/purple.png"
            alt="tailwind_blob_purple"
          />
        </div>
        <div className="relative order-first w-full px-4 md:order-last md:w-6/12">
          <div className="md:ml-7 lg:ml-24 lg:w-2/3">
            <Typography
              variant="h2"
              className="mb-2 font-black tracking-normal text-[#1A237E]"
            >
              Awesome <br />
              <Typography
                as="span"
                variant="h2"
                color="blue"
                className="inline-block font-black tracking-normal"
                textGradient
              >
                Platform
              </Typography>{" "}
              For Placement.
            </Typography>
            <Typography className="text-lg text-[#1A237E]/60 lg:pr-2">
              Designed for platform independence, Java is widely used for web
              development backend, Android app development, enterprise software,
              and networking applications.
            </Typography>
          </div>
        </div>
      </div>
    </section>
  );
}
